module.exports = __webpack_public_path__ + "static/media/photo39.754bc1c8.jpg";